/* ============================================================
   BlankPill — PRODUCT PAGE enrichment (mobile-first)
   Injects homepage-style content onto product pages:
   1. Acid ticker pinned at the very top (matches collection/home)
   2. A "COLD" scrolling marquee strip under the product info
   3. A brand "CULT CODE" feature strip (4 cards) + closing ticker
   All blocks are scroll-reveal tagged and GPU-safe. Idempotent:
   guarded so section reloads never double-inject. Reversible:
   delete this file + its <script> tag in blankpill-head.liquid.
   ============================================================ */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var SVG_STAR =
    '<svg class="bp-col-ticker__star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M12 2l2.4 6.9L21.5 9l-5.7 4.3 2.1 7-5.9-4.2-5.9 4.2 2.1-7L2.5 9l7.1-.1z"/></svg>';

  var TICKER_ITEMS = [
    'CERTIFIED CHRONICALLY ONLINE', 'SHIPS IN 48 HOURS', 'HEAVYWEIGHT COTTON',
    'BATCHED & NUMBERED DROPS', 'FREE WORLDWIDE OVER $60', '30-DAY NO-RISK RETURNS',
    'BUILT TO LAST', 'STAY COLD'
  ];

  var COLD_ITEMS = [
    'STAY COLD', 'COLD COLD COLD', 'NOTHING EVER HAPPENS', 'TOUCH GRASS LATER',
    'POSTED THROUGH IT', 'BUILT DIFFERENT', 'COLD COLD COLD', 'KEEP SCROLLING'
  ];

  var CREED = [
    { n: '01', h: 'Built To Last', p: 'Heavyweight cotton, double-stitched. Wash it a hundred times. It outlives the discourse.' },
    { n: '02', h: 'Numbered Drops', p: 'Batched, not mass-produced. When a drop is gone, it is gone. No restock, no cope.' },
    { n: '03', h: 'Ships In 48hr', p: 'Order today, it moves today. Tracked the whole way. No three-week dropship purgatory.' },
    { n: '04', h: 'Certified Online', p: 'Designed by and for the terminally posting. If you know, you know. If you don\u2019t, that\u2019s fine too.' }
  ];

  function tickerHTML(cls, items) {
    var one = items.map(function (t) {
      return '<span class="bp-col-ticker__item">' + SVG_STAR + t + '</span>';
    }).join('');
    // double the track for a seamless -50% loop
    return '<div class="' + cls + '"><div class="bp-col-ticker__track">' + one + one + '</div></div>';
  }

  function makeTopTicker() {
    if (document.querySelector('.bp-pdp-ticker')) return;
    var wrap = document.createElement('div');
    wrap.className = 'bp-pdp-ticker';
    wrap.innerHTML = tickerHTML('bp-col-ticker', TICKER_ITEMS);
    // place at very top of main content
    var main = document.querySelector('#MainContent, main, [role="main"]') || document.body;
    main.insertBefore(wrap, main.firstChild);
  }

  function makeColdMarquee(anchor) {
    if (document.querySelector('.bp-pdp-cold')) return;
    var strip = document.createElement('div');
    strip.className = 'bp-pdp-cold bp-a-reveal';
    strip.innerHTML = tickerHTML('bp-col-ticker bp-col-ticker--dark', COLD_ITEMS);
    anchor.parentNode.insertBefore(strip, anchor.nextSibling);
  }

  function makeCreed(anchor) {
    if (document.querySelector('.bp-pdp-creed')) return;
    var cards = CREED.map(function (c) {
      return '<div class="bp-creed-card bp-a-reveal">' +
        '<span class="bp-creed-num">' + c.n + '</span>' +
        '<h3 class="bp-creed-h">' + c.h + '</h3>' +
        '<p class="bp-creed-p">' + c.p + '</p>' +
      '</div>';
    }).join('');
    var sec = document.createElement('section');
    sec.className = 'bp-creed bp-pdp-creed bp-root';
    sec.innerHTML =
      '<div class="bp-creed-head bp-a-reveal">' +
        '<div class="bp-creed-mark"><svg class="bp-creed-mark-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7z"/></svg></div>' +
        '<h2 class="bp-creed-title">The Cult Code</h2>' +
        '<p class="bp-creed-sub">// Why people keep coming back</p>' +
      '</div>' +
      '<div class="bp-creed-grid">' + cards + '</div>';
    anchor.parentNode.insertBefore(sec, anchor.nextSibling);
  }

  function makeBottomTicker(anchor) {
    if (document.querySelector('.bp-pdp-ticker-bottom')) return;
    var wrap = document.createElement('div');
    wrap.className = 'bp-pdp-ticker-bottom bp-a-reveal';
    wrap.innerHTML = tickerHTML('bp-col-ticker', TICKER_ITEMS);
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  /* Eyebrow tag ("DOSE \u00b7 <type>") injected above the product title. */
  function makeEyebrow() {
    if (document.querySelector('.bp-pdp-eyebrow')) return;
    var title = document.querySelector(
      '.product-title, h1.h1, .product__title h1, .product-information h1, h1'
    );
    if (!title) return;
    // Derive a short label from the product type / tag if present.
    var typeEl = document.querySelector('[class*="product-type"], .product__type');
    var label = 'DOSE';
    var t = (document.body.getAttribute('data-product-type') ||
             (typeEl && typeEl.textContent) || '').trim().toUpperCase();
    if (!t) {
      // crude guess from URL
      var p = window.location.pathname.toLowerCase();
      if (p.indexOf('hood') !== -1) t = 'HOODIE';
      else if (p.indexOf('plush') !== -1) t = 'PLUSH';
      else t = 'DROP';
    }
    var eb = document.createElement('div');
    eb.className = 'bp-pdp-eyebrow';
    eb.textContent = label + ' \u00b7 ' + t;
    title.parentNode.insertBefore(eb, title);
  }

  /* Value-prop row injected under the price. */
  function makeValueProps() {
    if (document.querySelector('.bp-pdp-valueprops')) return;
    var priceBlock = document.querySelector(
      '.product-price, .price, [class*="price"]'
    );
    if (!priceBlock) return;
    // walk up to a sensible container so it sits under the whole price
    var anchor = priceBlock.closest('.price, .product-price') || priceBlock;
    var row = document.createElement('div');
    row.className = 'bp-pdp-valueprops';
    row.innerHTML =
      '<span>Ships 48hr</span>' +
      '<span>Free worldwide $60+</span>' +
      '<span>30-day returns</span>';
    anchor.parentNode.insertBefore(row, anchor.nextSibling);
  }

  function build() {
    makeTopTicker();
    makeEyebrow();
    makeValueProps();

    // Anchor everything else after the reviews section when present
    // (reviews sit directly under the buy box), else the product info.
    var info = document.querySelector('.product-information, .product-details, .product__info, .product');
    var bpRev = document.getElementById('bp-reviews');
    if (bpRev) info = bpRev.closest('.shopify-section') || bpRev;
    var recs = document.querySelector('product-recommendations, .product-recommendations');

    if (info) {
      makeColdMarquee(info);
    }
    // Creed + closing ticker go just above recommendations if present,
    // else after the product info.
    var creedAnchor = recs || info;
    if (creedAnchor) {
      makeCreed(creedAnchor);
      var creedEl = document.querySelector('.bp-pdp-creed');
      makeBottomTicker(creedEl || creedAnchor);
    }

    // Re-tag reveals so the new blocks animate in.
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () {
        document.dispatchEvent(new CustomEvent('bp:rescan'));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(build, 60); });
})();



/* ============================================================
   BLANKPILL — Squatch-style PDP info sections
   Injects (below the buy box, per product type):
   1. A 3-column value-prop band (dark, acid hand-drawn icons)
   2. A 2x2 checkerboard: brand text panel + product imagery,
      then imagery + second text panel (alternating).
   Copy varies for shirts / hoodies / plushies. Images come from
   the product's own gallery via the shared product fetch.
   Idempotent + reversible: remove this block to undo.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;

  var ICO = {
    thread: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7c2.5-.3 5 1.4 5.2 4.3.15 2.3-1.3 3.6-2.7 4.8-1.5 1.3-3 2.6-2.8 5 .2 2.9 2.8 4.6 5.3 4.3"/><path d="M26 25c-2.5.3-5-1.4-5.2-4.3-.15-2.3 1.3-3.6 2.7-4.8 1.5-1.3 3-2.6 2.8-5C26.1 8 23.5 6.3 21 6.6"/><path d="M12.5 12.5l7 7M19.5 12.5l-7 7"/></svg>',
    star: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M16 4l3.2 7.6 8.3.6-6.3 5.3 2 8-7.2-4.4-7.2 4.4 2-8L4.5 12.2l8.3-.6z"/></svg>',
    eye: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 16c3-5 7.6-8 12.5-8s9.5 3 12.5 8c-3 5-7.6 8-12.5 8s-9.5-3-12.5-8z"/><circle cx="16" cy="16" r="3.4"/></svg>',
    pill: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="8" y="4.5" width="16" height="23" rx="8"/><path d="M8.5 16h15"/></svg>',
    skull: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M16 4c-6 0-10 4.2-10 9.8 0 3.2 1.4 5.3 3 6.7.5.45.8 1 .8 1.7v1.6c0 .8.6 1.4 1.4 1.4h9.6c.8 0 1.4-.6 1.4-1.4v-1.6c0-.7.3-1.25.8-1.7 1.6-1.4 3-3.5 3-6.7C26 8.2 22 4 16 4z"/><circle cx="12" cy="14.5" r="1.8" fill="currentColor"/><circle cx="20" cy="14.5" r="1.8" fill="currentColor"/><path d="M14.5 25v-2.5M17.5 25v-2.5" stroke-linecap="round"/></svg>'
  };

  var CONTENT = {
    shirt: {
      band: [
        { ico: 'thread', h: 'Heavyweight Cotton', p: '5 oz+ combed cotton with taped neck and shoulders. No paper-thin print-on-demand feel — this survives the wash and the discourse.' },
        { ico: 'star', h: 'Original Art', p: 'Hand-drawn designs you won’t find on a mall rack. Printed to order — crisp lines, deep blacks, zero warehouse dust.' },
        { ico: 'eye', h: 'Made For The Online', p: 'Designed by and for the terminally posting. If you know, you know. If you don’t, that’s fine too.' }
      ],
      rows: [
        { eyebrow: 'Pure Heavyweight', title: 'Built Different.', copy: 'Pre-shrunk, double-seamed sleeves and hems, true-to-size fit. Wash it a hundred times — it keeps its shape while the timeline loses its mind.', theme: 'acid' },
        { eyebrow: 'Printed To Order', title: 'Fresh Off The Press.', copy: 'Every shirt is printed the moment you order it, then out the door within 48 hours — tracked the whole way. Free worldwide shipping over $60.', theme: 'dark' }
      ]
    },
    hoodie: {
      band: [
        { ico: 'thread', h: 'Heavy-Blend Fleece', p: 'Thick, structured fleece with a double-lined hood and reinforced pouch pocket. Built for long sessions and cold rooms.' },
        { ico: 'star', h: 'Original Art', p: 'Hand-drawn designs printed to order — crisp lines, deep blacks, no mass-market reprints.' },
        { ico: 'skull', h: 'Built For Indoors', p: 'Wear it indoors. Wear it to the function. Wear it forever. Designed for the chronically online.' }
      ],
      rows: [
        { eyebrow: 'Pure Insulation', title: 'Touch No Grass.', copy: 'Roomy fit, matching drawcord, zero shrink surprises. The official uniform of staying in — built to outlast every arc of the discourse.', theme: 'acid' },
        { eyebrow: 'Printed To Order', title: 'Fresh Off The Press.', copy: 'Every hoodie is printed the moment you order it, then ships within 48 hours — tracked the whole way. Free worldwide shipping over $60.', theme: 'dark' }
      ]
    },
    plush: {
      band: [
        { ico: 'star', h: 'Collectible Grade', p: 'Embroidered face for clean detail and durability, soft premium synthetic fabric, custom stitched shirt design.' },
        { ico: 'pill', h: 'Limited Batches', p: 'Plushies drop in numbered batches. When a batch sells out, the next one can take 4–6 weeks — lock your spot early.' },
        { ico: 'eye', h: 'Desk-Ready', p: '6–7 inches of pure presence. Built to be displayed — desks, shelves, gaming setups, studio corners.' }
      ],
      rows: [
        { eyebrow: 'Pure Presence', title: 'The Shelf Demands It.', copy: 'Compact, display-ready, and impossible to explain to guests. Embroidered detailing intact, energy fully loaded.', theme: 'acid' },
        { eyebrow: 'Batched Drops', title: 'When It’s Gone, It’s Gone.', copy: 'Each batch is limited. Pre-order to lock your spot, or grab restock alerts — we ping you the moment the next batch lands.', theme: 'dark' }
      ]
    }
  };

  function catOf(p) {
    var hay = ((p ? (p.type + ' ' + p.title) : '') + ' ' + document.title).toLowerCase();
    if (hay.indexOf('hood') !== -1) return 'hoodie';
    if (hay.indexOf('plush') !== -1) return 'plush';
    return 'shirt';
  }

  /* Custom hand-drawn SVG art panels (replace 2nd listing photo). */
  var BP_ART = {
    shirt: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Heavyweight tee illustration">' +
      '<path d="M140 70 L85 105 L105 160 L135 148 L135 330 L265 330 L265 148 L295 160 L315 105 L260 70 C245 95 155 95 140 70 Z"/>' +
      '<path d="M150 88 C170 108 230 108 250 88" stroke-dasharray="5 6"/>' +
      '<path d="M142 318 L258 318" stroke-dasharray="5 6"/>' +
      '<rect x="178" y="178" width="44" height="86" rx="22"/><path d="M180 221 h40"/>' +
      '<path d="M95 212 v26 M82 225 h26"/>' +
      '<path d="M318 196 c2 12 8 20 20 22 -12 2 -18 10 -20 22 -2 -12 -8 -20 -20 -22 12 -2 18 -10 20 -22z" fill="#e8f65c" stroke="none"/>' +
      '<circle cx="322" cy="298" r="13"/>' +
      '<path d="M64 300 c10 -12 20 -12 30 0 s20 12 30 0"/></svg>',
    hoodie: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Heavy-blend hoodie illustration">' +
      '<path d="M148 92 L92 122 L112 182 L138 172 L138 330 L262 330 L262 172 L288 182 L308 122 L252 92"/>' +
      '<path d="M148 92 C150 58 250 58 252 92 C240 118 160 118 148 92 Z"/>' +
      '<path d="M162 96 C170 112 230 112 238 96"/>' +
      '<path d="M186 114 l-4 44 M214 114 l4 44"/>' +
      '<circle cx="182" cy="162" r="3.2" fill="#e8f65c" stroke="none"/><circle cx="218" cy="162" r="3.2" fill="#e8f65c" stroke="none"/>' +
      '<path d="M160 256 L240 256 L230 312 L170 312 Z" stroke-dasharray="6 6"/>' +
      '<path d="M140 322 L260 322" stroke-dasharray="5 6"/>' +
      '<path d="M330 150 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/>' +
      '<path d="M60 220 c10 -12 20 -12 30 0 s20 12 30 0"/></svg>',
    plush: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Collectible plush illustration">' +
      '<path d="M200 92 c58 0 92 44 92 98 0 68 -44 118 -92 118 s-92 -50 -92 -118 c0 -54 34 -98 92 -98z"/>' +
      '<path d="M108 212 c-18 4 -26 18 -19 32 M292 212 c18 4 26 18 19 32"/>' +
      '<circle cx="172" cy="182" r="6" fill="#e8f65c" stroke="none"/><circle cx="228" cy="182" r="6" fill="#e8f65c" stroke="none"/>' +
      '<path d="M176 222 c14 14 34 14 48 0" stroke-dasharray="5 5"/>' +
      '<path d="M200 92 v-16 M192 68 h16"/>' +
      '<path d="M312 128 c5 -8 16 -6 18 1 2 8 -5 13 -18 21 -13 -8 -20 -13 -18 -21 2 -7 13 -9 18 -1z"/>' +
      '<path d="M76 150 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/>' +
      '<circle cx="90" cy="300" r="12"/></svg>'
  };

  /* Second illustration set — replaces the remaining listing photo. */
  var BP_ARTB = {
    shirt: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Tee on hanger illustration">' +
      '<path d="M200 44 c-10 0 -16 8 -14 16 M200 44 c12 0 18 12 10 20 l-10 8"/>' +
      '<path d="M200 72 L96 116 L304 116 Z"/>' +
      '<path d="M148 116 L112 146 L130 186 L152 176 L152 330 L248 330 L248 176 L270 186 L288 146 L252 116"/>' +
      '<path d="M158 320 L242 320" stroke-dasharray="5 6"/>' +
      '<path d="M172 210 h56 M172 234 h38" stroke-dasharray="6 5"/>' +
      '<path d="M330 90 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/>' +
      '<path d="M62 250 v24 M50 262 h24"/>' +
      '<circle cx="330" cy="300" r="12"/></svg>',
    hoodie: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Hood up illustration">' +
      '<path d="M200 60 c-64 0 -96 52 -96 108 v70 c0 10 8 18 18 18 h156 c10 0 18 -8 18 -18 v-70 c0 -56 -32 -108 -96 -108z"/>' +
      '<path d="M200 96 c-36 0 -56 30 -56 64 0 30 24 56 56 56 s56 -26 56 -56 c0 -34 -20 -64 -56 -64z"/>' +
      '<path d="M186 222 l-5 48 M214 222 l5 48"/>' +
      '<circle cx="180" cy="274" r="3.2" fill="#e8f65c" stroke="none"/><circle cx="220" cy="274" r="3.2" fill="#e8f65c" stroke="none"/>' +
      '<path d="M60 130 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/>' +
      '<path d="M328 110 v24 M316 122 h24"/>' +
      '<path d="M310 300 c10 -12 20 -12 30 0"/></svg>',
    plush: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Boxed plush illustration">' +
      '<path d="M92 216 h216 v118 H92z"/>' +
      '<path d="M80 180 h240 v36 H80z"/>' +
      '<path d="M200 180 v154 M200 180 c-14 -22 -40 -26 -50 -12 -8 12 6 22 50 12z M200 180 c14 -22 40 -26 50 -12 8 12 -6 22 -50 12z"/>' +
      '<path d="M148 180 c0 -34 22 -60 52 -60 s52 26 52 60"/>' +
      '<circle cx="182" cy="146" r="4.4" fill="#e8f65c" stroke="none"/><circle cx="218" cy="146" r="4.4" fill="#e8f65c" stroke="none"/>' +
      '<path d="M188 162 c8 7 16 7 24 0" stroke-dasharray="4 4"/>' +
      '<path d="M330 96 c5 -8 16 -6 18 1 2 8 -5 13 -18 21 -13 -8 -20 -13 -18 -21 2 -7 13 -9 18 -1z"/>' +
      '<path d="M58 110 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/></svg>'
  };

  function buildSq() {
    if (document.querySelector('.bp-sq-band')) return;
    var anchor = document.querySelector('.product-information, .product-details, .product__info, .product');
    var bpRev = document.getElementById('bp-reviews');
    if (bpRev) anchor = bpRev.closest('.shopify-section') || bpRev;
    if (!anchor) return;
    var fetchP = window.__bpProductFetch ? window.__bpProductFetch() : Promise.resolve(null);
    fetchP.then(function (p) {
      if (document.querySelector('.bp-sq-band')) return;
      var cat = catOf(p);
      var c = CONTENT[cat];
      var imgs = (p && p.images) || [];
      var img1 = imgs[1] || imgs[0] || '';

      var band = document.createElement('section');
      band.className = 'bp-sq-band';
      band.innerHTML = c.band.map(function (b) {
        return '<div class="bp-sq-band__item"><span class="bp-sq-band__ico">' + ICO[b.ico] + '</span><h3 class="bp-sq-band__h">' + b.h + '</h3><p class="bp-sq-band__p">' + b.p + '</p></div>';
      }).join('');

      var r0 = c.rows[0], r1 = c.rows[1];
      var split = document.createElement('section');
      split.className = 'bp-sq-split';
      split.innerHTML =
        '<div class="bp-sq-cell bp-sq-cell--text-' + r0.theme + '"><div><p class="bp-sq-eyebrow">' + r0.eyebrow + '</p><h2 class="bp-sq-title">' + r0.title + '</h2><p class="bp-sq-copy">' + r0.copy + '</p></div></div>' +
        '<div class="bp-sq-cell bp-sq-cell--art">' + BP_ARTB[cat] + '</div>' +
        '<div class="bp-sq-cell bp-sq-cell--art">' + BP_ART[cat] + '</div>' +
        '<div class="bp-sq-cell bp-sq-cell--text-' + r1.theme + '"><div><p class="bp-sq-eyebrow">' + r1.eyebrow + '</p><h2 class="bp-sq-title">' + r1.title + '</h2><p class="bp-sq-copy">' + r1.copy + '</p></div></div>';

      anchor.parentNode.insertBefore(band, anchor.nextSibling);
      band.parentNode.insertBefore(split, band.nextSibling);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildSq);
  else buildSq();
  document.addEventListener('shopify:section:load', function () { setTimeout(buildSq, 80); });
})();



/* ============================================================
   BLANKPILL — Squatch-style PDP v2
   Extends the v1 sections with: a full-width hero color-block
   banner with floating hand-drawn SVG doodles, a third
   checkerboard row, checker-patterned product tiles, and a
   4-up specs strip. All per product type. Reversible.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname)) return;

  var D = {
    pill: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="8" y="4.5" width="16" height="23" rx="8"/><path d="M8.5 16h15"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5c.6 3.6 2.4 6.4 6 7-3.6.6-5.4 3.4-6 7-.6-3.6-2.4-6.4-6-7 3.6-.6 5.4-3.4 6-7z"/></svg>',
    ring: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="16" cy="16" r="10"/></svg>',
    squig: '<svg viewBox="0 0 48 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M2 8c4-6 8-6 12 0s8 6 12 0 8-6 12 0"/></svg>',
    bolt: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M18.5 3.5c-.4 2-3.8 9.2-7.6 12.1-.6.5-.3 1.2.5 1.2 1.7.1 4.3.1 5.2.2.6 0 .8.4.6 1.1-.8 2.6-2 7-2.2 9.4-.05.6.5.9.95.45 2.6-2.7 8.6-9.6 11.1-13.2.4-.6.05-1.2-.7-1.2-1.6-.05-3.9-.1-5-.15-.6-.03-.85-.45-.6-1.1.8-2.2 1.7-5.6 2-7.9.08-.65-.5-1-.95-.5-.9 1-2.4 2.8-3.85 4.4"/></svg>',
    star: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M16 4l3.2 7.6 8.3.6-6.3 5.3 2 8-7.2-4.4-7.2 4.4 2-8L4.5 12.2l8.3-.6z"/></svg>',
    thread: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7c2.5-.3 5 1.4 5.2 4.3.15 2.3-1.3 3.6-2.7 4.8-1.5 1.3-3 2.6-2.8 5 .2 2.9 2.8 4.6 5.3 4.3"/><path d="M26 25c-2.5.3-5-1.4-5.2-4.3-.15-2.3 1.3-3.6 2.7-4.8 1.5-1.3 3-2.6 2.8-5C26.1 8 23.5 6.3 21 6.6"/><path d="M12.5 12.5l7 7M19.5 12.5l-7 7"/></svg>',
    ret: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"><path d="M9 9.5c-.6 1.4-1.4 3.2-1.8 4.6-.2.6.2 1 .8.95 1.6-.1 4.1-.4 5.6-.6"/><path d="M7.4 14c1.6-3.6 5.4-7.2 9.8-7.1 5 .1 9.3 4.3 9.2 9.6-.1 5.2-4.4 9.2-9.6 9.1-3.8-.05-7-2.3-8.4-5.5"/></svg>',
    spiral: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M16 16c0-2 2.5-3 4-1.5s1 4.5-1 5.5-5.5.5-7-2 .5-6.5 3.5-7.5 7.5 0 9 3 .5 7.5-2.5 9.5-8 1.5-11-1.5"/></svg>',
    target: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2"><circle cx="16" cy="16" r="11"/><circle cx="16" cy="16" r="5.5"/><circle cx="16" cy="16" r="1.4" fill="currentColor"/></svg>',
    aster: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M16 4v24M4 16h24M7.5 7.5l17 17M24.5 7.5l-17 17"/></svg>',
    arrow: '<svg viewBox="0 0 40 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18c8 4 22 2 30-8"/><path d="M27 8l6 2-1 6"/></svg>',
    glasses: '<svg viewBox="0 0 40 20" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="6.5"/><circle cx="29" cy="11" r="6.5"/><path d="M17.5 11h5M4.5 11 2 8M35.5 11 38 8"/></svg>',
    heart: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M16 27c-6-4.5-11-8.5-11-14a6 6 0 0 1 11-3 6 6 0 0 1 11 3c0 5.5-5 9.5-11 14z"/></svg>',
    eyeD: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 16c3-5 7.6-8 12.5-8s9.5 3 12.5 8c-3 5-7.6 8-12.5 8s-9.5-3-12.5-8z"/><circle cx="16" cy="16" r="3.4"/></svg>',
    skullD: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M16 4c-6 0-10 4.2-10 9.8 0 3.2 1.4 5.3 3 6.7.5.45.8 1 .8 1.7v1.6c0 .8.6 1.4 1.4 1.4h9.6c.8 0 1.4-.6 1.4-1.4v-1.6c0-.7.3-1.25.8-1.7 1.6-1.4 3-3.5 3-6.7C26 8.2 22 4 16 4z"/><circle cx="12" cy="14.5" r="1.8" fill="currentColor"/><circle cx="20" cy="14.5" r="1.8" fill="currentColor"/></svg>'
  };

  var V2 = {
    shirt: {
      hero: { cls: 'acid', eyebrow: 'The BlankPill Standard', title: 'Wearable Posting.', sub: 'Heavyweight cotton. Original art. Zero explanation provided.' },
      row: { eyebrow: 'One Of One Energy', title: 'No Reprints. No Reruns.', copy: 'Designs rotate with the discourse. When a drop leaves the lineup, it’s gone — screenshot it or wear it.' },
      specs: [['bolt', '48hr Dispatch'], ['thread', 'Heavyweight Build'], ['star', 'Original Art'], ['ret', '30-Day Returns']]
    },
    hoodie: {
      hero: { cls: 'dark', eyebrow: 'The BlankPill Standard', title: 'Maximum Comfort Arc.', sub: 'Heavy-blend fleece for the permanently indoors.' },
      row: { eyebrow: 'Certified Cozy', title: 'Hibernate In Style.', copy: 'Fleece-lined, hood up, notifications off. Cozy enough for the long arc, sturdy enough for the outside world — if it comes to that.' },
      specs: [['bolt', '48hr Dispatch'], ['thread', 'Heavy-Blend Fleece'], ['star', 'Original Art'], ['ret', '30-Day Returns']]
    },
    plush: {
      hero: { cls: 'sky', eyebrow: 'Collectible Division', title: 'Pocket-Sized Chaos.', sub: '6–7 inches. Embroidered. Limited. Yours.' },
      row: { eyebrow: 'Gift-Grade', title: 'For You, Or A Chud You Know.', copy: 'Ships boxed and display-ready. The rare gift that says “I understand your internet” without saying anything at all.' },
      specs: [['bolt', '48hr Dispatch'], ['star', 'Limited Batches'], ['thread', 'Embroidered Detail'], ['ret', '30-Day Returns']]
    }
  };

  /* [icon, top, left, size(px), rotate(deg)] */
  var DOODLES = [
    ['pill', '7%', '4%', 72, -18],
    ['spark', '64%', '8%', 44, 0],
    ['ring', '10%', '89%', 80, 8],
    ['squig', '75%', '76%', 110, -6],
    ['star', '56%', '22%', 52, 14],
    ['target', '22%', '76%', 72, 0],
    ['aster', '14%', '34%', 40, 20],
    ['spiral', '68%', '52%', 60, -12],
    ['arrow', '34%', '8%', 92, -8],
    ['glasses', '12%', '58%', 84, -5],
    ['heart', '78%', '34%', 40, 15],
    ['eyeD', '40%', '90%', 56, -10],
    ['skullD', '82%', '12%', 48, 8],
    ['pill', '80%', '90%', 44, 30]
  ];

  /* corner doodle sets for the checkerboard text panels */
  var CELLSETS = [
    [['spark', '8%', '6%', 34, 0], ['ring', '70%', '84%', 64, 10], ['aster', '12%', '84%', 38, 15], ['glasses', '82%', '10%', 66, -6]],
    [['pill', '10%', '7%', 52, -20], ['heart', '74%', '88%', 40, 10], ['squig', '82%', '8%', 84, -5], ['star', '14%', '86%', 40, 18]],
    [['target', '10%', '84%', 60, 0], ['spark', '76%', '8%', 34, 0], ['star', '66%', '88%', 44, 12], ['spiral', '14%', '8%', 44, -10]]
  ];

  /* Custom quality-badge SVG art panels (replace 3rd listing photo). */
  var BP_ART2 = {
    shirt: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Heavyweight quality badge">' +
      '<circle cx="200" cy="168" r="92" stroke-dasharray="4 9"/>' +
      '<circle cx="200" cy="168" r="116" opacity="0.35"/>' +
      '<path d="M200 108 l16 38 41 3 -31 27 10 40 -36 -22 -36 22 10 -40 -31 -27 41 -3z"/>' +
      '<path d="M96 88 v22 M85 99 h22 M306 260 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/>' +
      '<text x="200" y="322" text-anchor="middle" font-family="Space Mono, monospace" font-size="21" font-weight="700" fill="#e8f65c" stroke="none" letter-spacing="2">5.3 OZ HEAVYWEIGHT</text>' +
      '<text x="200" y="352" text-anchor="middle" font-family="Space Mono, monospace" font-size="12" fill="#e8f65c" stroke="none" opacity="0.65" letter-spacing="1.5">PRE-SHRUNK · DOUBLE-STITCHED · TRUE TO SIZE</text></svg>',
    hoodie: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Heavy-blend fleece badge">' +
      '<circle cx="200" cy="168" r="92" stroke-dasharray="4 9"/>' +
      '<circle cx="200" cy="168" r="116" opacity="0.35"/>' +
      '<path d="M162 128 c14 -2 28 8 29 24 1 13 -7 20 -15 27 -8 7 -17 14 -16 28 1 16 15 26 29 24"/>' +
      '<path d="M238 208 c-14 2 -28 -8 -29 -24 -1 -13 7 -20 15 -27 8 -7 17 -14 16 -28 -1 -16 -15 -26 -29 -24"/>' +
      '<path d="M178 152 l44 44 M222 152 l-44 44"/>' +
      '<path d="M96 88 v22 M85 99 h22"/>' +
      '<text x="200" y="322" text-anchor="middle" font-family="Space Mono, monospace" font-size="21" font-weight="700" fill="#e8f65c" stroke="none" letter-spacing="2">HEAVY-BLEND FLEECE</text>' +
      '<text x="200" y="352" text-anchor="middle" font-family="Space Mono, monospace" font-size="12" fill="#e8f65c" stroke="none" opacity="0.65" letter-spacing="1.5">DOUBLE-LINED HOOD · NO PILLING · BUILT WARM</text></svg>',
    plush: '<svg viewBox="0 0 400 400" fill="none" stroke="#e8f65c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" role="img" aria-label="Limited batch badge">' +
      '<circle cx="200" cy="168" r="92" stroke-dasharray="4 9"/>' +
      '<circle cx="200" cy="168" r="116" opacity="0.35"/>' +
      '<rect x="176" y="112" width="48" height="112" rx="24"/><path d="M178 168 h44"/>' +
      '<path d="M306 100 c2 10 7 17 17 19 -10 2 -15 9 -17 19 -2 -10 -7 -17 -17 -19 10 -2 15 -9 17 -19z" fill="#e8f65c" stroke="none"/>' +
      '<path d="M96 250 v22 M85 261 h22"/>' +
      '<text x="200" y="322" text-anchor="middle" font-family="Space Mono, monospace" font-size="21" font-weight="700" fill="#e8f65c" stroke="none" letter-spacing="2">LIMITED BATCH</text>' +
      '<text x="200" y="352" text-anchor="middle" font-family="Space Mono, monospace" font-size="12" fill="#e8f65c" stroke="none" opacity="0.65" letter-spacing="1.5">EMBROIDERED DETAIL · NUMBERED DROPS</text></svg>'
  };

  function buildV2() {
    var split = document.querySelector('.bp-sq-split');
    if (!split || document.querySelector('.bp-sq-hero')) return;
    var fetchP = window.__bpProductFetch ? window.__bpProductFetch() : Promise.resolve(null);
    fetchP.then(function (p) {
      if (document.querySelector('.bp-sq-hero')) return;
      var hay = ((p ? (p.type + ' ' + p.title) : '') + ' ' + document.title).toLowerCase();
      var cat = hay.indexOf('hood') !== -1 ? 'hoodie' : (hay.indexOf('plush') !== -1 ? 'plush' : 'shirt');
      var v = V2[cat];

      /* hero color-block banner with floating doodles */
      var hero = document.createElement('section');
      hero.className = 'bp-sq-hero bp-sq-hero--' + v.hero.cls;
      hero.innerHTML = DOODLES.map(function (d) {
        return '<span class="bp-sq-doodle" style="top:' + d[1] + ';left:' + d[2] + ';width:' + d[3] + 'px;height:' + d[3] + 'px;--r:' + d[4] + 'deg">' + D[d[0]] + '</span>';
      }).join('') +
        '<p class="bp-sq-hero__eyebrow">' + v.hero.eyebrow + '</p>' +
        '<h2 class="bp-sq-hero__title">' + v.hero.title + '</h2>' +
        '<p class="bp-sq-hero__sub">' + v.hero.sub + '</p>';
      split.parentNode.insertBefore(hero, split);

      /* third checkerboard row */
      var c5 = document.createElement('div');
      c5.className = 'bp-sq-cell bp-sq-cell--text-acid';
      c5.innerHTML = '<div><p class="bp-sq-eyebrow">' + v.row.eyebrow + '</p><h2 class="bp-sq-title">' + v.row.title + '</h2><p class="bp-sq-copy">' + v.row.copy + '</p></div>';
      var c6 = document.createElement('div');
      c6.className = 'bp-sq-cell bp-sq-cell--art';
      c6.innerHTML = BP_ART2[cat];
      split.appendChild(c5);
      split.appendChild(c6);

      /* tiles stay seamless white — the mockups' own white background blends in */

      /* specs strip */
      var specs = document.createElement('section');
      specs.className = 'bp-sq-specs';
      specs.innerHTML = v.specs.map(function (s) {
        return '<div class="bp-sq-specs__item"><span class="bp-sq-specs__ico">' + D[s[0]] + '</span><span class="bp-sq-specs__label">' + s[1] + '</span></div>';
      }).join('');
      split.parentNode.insertBefore(specs, split.nextSibling);

      /* sprinkle corner doodles into every checkerboard text panel */
      Array.prototype.forEach.call(document.querySelectorAll('.bp-sq-cell--text-acid, .bp-sq-cell--text-dark'), function (cell, i) {
        if (cell.querySelector('.bp-sq-doodle--cell')) return;
        CELLSETS[i % CELLSETS.length].forEach(function (d) {
          var s = document.createElement('span');
          s.className = 'bp-sq-doodle bp-sq-doodle--cell';
          s.style.cssText = 'top:' + d[1] + ';left:' + d[2] + ';width:' + d[3] + 'px;height:' + d[3] + 'px;--r:' + d[4] + 'deg';
          s.innerHTML = D[d[0]];
          cell.appendChild(s);
        });
      });
    });
  }

  function tryBuild(n) {
    if (document.querySelector('.bp-sq-split')) { buildV2(); }
    else if (n < 24) { setTimeout(function () { tryBuild(n + 1); }, 250); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tryBuild(0); });
  else tryBuild(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { tryBuild(0); }, 100); });
})();